import Text from "common/Typography/Text.tsx";
import styled, { css } from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

export const Title = styled(Text).attrs({ $weight: 600 })`
  font-size: 28px;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      && {
        ${newLookType.pageTitle};
        color: ${getNewLookTokens(p.theme).ink};
      }
    `}
`;

export const Description = styled(Text).attrs({ type: "medium" })`
  margin-bottom: 30px;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      && {
        margin-top: 8px;
        margin-bottom: 20px;
        ${newLookType.body};
        color: ${getNewLookTokens(p.theme).secondary};
      }
    `}
`;

/** The new-look card around each step of the cancellation flow. */
export const newLookPanel = css`
  padding: 24px;
  background: ${(p) => getNewLookTokens(p.theme).panel};
  border: ${(p) => p.theme.borders.panel};
  border-radius: ${(p) => p.theme.radii.card}px;
  box-shadow: ${(p) => p.theme.shadows.panel};
`;
